export const isProduction = process.env.NODE_ENV === "production";

export const isLocalhost = window.location.hostname === "localhost";

export const isDev = !isProduction;
